import img1 from "../../images/preview/demo/img-1.jpg";
import img2 from "../../images/preview/demo/img-2.jpg";
import img3 from "../../images/preview/demo/img-3.jpg";
import img4 from "../../images/preview/demo/img-4.jpg";
import img5 from "../../images/preview/demo/img-5.jpg";
import img6 from "../../images/preview/demo/img-6.jpg";
import img7 from "../../images/preview/demo/img-7.jpg";
import coming from "../../images/preview/demo/coming.png";
import tshape from "../../images/preview/title-1.png";

const demoItems = [
  { img: img1, link: "https://bohu.wpolive.com/", title: "Wedding Home Style 1" },
  { img: img2, link: "https://bohu.wpolive.com/wedding-home-style-2/", title: "Wedding Home Style 2" },
  { img: img3, link: "https://bohu.wpolive.com/wedding-home-style-3/", title: "Wedding Home Style 3" },
  { img: img4, link: "https://bohu.wpolive.com/wedding-planner-style-1/", title: "Wedding Planner 1" },
  { img: img5, link: "https://bohu.wpolive.com/wedding-planner-style-2/", title: "Wedding Planner 2" },
  { img: img6, link: "https://bohu.wpolive.com/wedding-shop-home/", title: "Wedding Shop Home" },
  { img: img7, link: "https://bohu.wpolive.com/wedding-invitation/", title: "Wedding Invitation" },
  { img: coming, link: "https://bohu.wpolive.com/coming-soon/", title: "Coming Soon" },
];

const Demos = () => {
  return (
    <section className="wpo-demo-section section-padding" id="demo">
      <div className="container-fluid">

        {/* Title */}
        <div className="row justify-content-center">
          <div className="col col-lg-6">
            <div className="preview-section-title">
              <div className="wow fadeInDown" data-wow-duration="1800ms">
                <i>
                  <img src={tshape} alt="" />
                </i>
              </div>
              <h2 className="poort-text poort-in-right">{demoItems.length}+ Unique Home Design</h2>
              <p className="poort-text poort-in-right">
                We Happily Prepared Various Homes for Your Big Day. Pick One of
                Our Beautiful Homepages to Start Your Dreamy Wedding Website!
              </p>
            </div>
          </div>
        </div>

        {/* Demo Grid */}
        <div className="row">
          <div className="col col-xs-12">
            <div className="wpo-demo-grids clearfix">
              {demoItems.map((item, index) => (
                <div
                  key={index}
                  className="grid wow fadeInUp"
                  data-wow-duration={`${1000 + index * 200}ms`}
                >
                  <div className="inner">
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt={item.title} />
                    </a>
                  </div>
                  <h3>{item.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Demos;
